<template>
  <div >
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3 mb-base" >
        <vx-card  slot="no-body" :title="$t('Decarbonization.Title')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(roles.collaborators)">
          <menu-control :items="decarbonizationItems">
          </menu-control>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(roles.admins)">
         <admin />
      </div>
    </div>
  </div>
</template>
<script>

import roles from './roles.js'
import menuControl from '@/app/shared/components/lists/menu.vue'
import admin from './admin/components/admin.vue'

export default {
  components: {
    menuControl,
    admin
  },
  data () {
    return {
      roles,
      decarbonizationItems : [ 
        {
          roles : roles.collaborators,
          icon : "BarChart2Icon",
          to : "/bsg/decarbonization/energyScenarios",
          i18nTitle : "Decarbonization.EnergyScenarios.Title"
        },
        {
          roles : roles.readers,
          icon : "BarChart2Icon",
          to : "/bsg/decarbonization/report",
          i18nTitle : "Decarbonization.Report"
        }
      ]
    }
  }
}
</script>